export default "__VITE_ASSET__DUZTItkS__"